import img_quet_qr from "./images/quet_qr.png";
import { useReducer, useState, useEffect } from "react";
import "./App.css";
import CurrencyInput from "react-currency-input-field";
import useScript from "./hooks/useScript";
import Select from "react-select";
import {
  GetVouchers,
  GetCurrentEvent,
  GetHoiVienCSMO,
  InsertNewTicketBooking,
  InsertErrorLog,
} from "./helpers/creator-api";

// App Constants (Immutable Globals)
const txt_form_QR4 = "Sau khi thanh toán thành công, hệ thống sẽ gửi";
const txt_form_QR5 =
  "xác nhận kèm mã tham dự sự kiện qua tin nhắn Zalo hoặc đường Email (vui lòng kiểm tra thư mục Inbox hoặc Spam).";
const underQRText = "QR code có hiệu lực trong 24h. Nếu qua thời gian hiệu lực, vui lòng đăng ký lại từ đầu.";
const debugging = false;

const formReducer = (state, event) => {
  if (event.type === "UPDATE_FIELDS") {
    return {
      ...state,
      ...event.values,
    };
  }
  return {
    ...state,
    [event.name]: event.value,
  };
};

function App() {
  // Form and Dialog State
  const [formData, setFormData] = useReducer(formReducer, {
    isHoiVienChinhThuc: false,
    isHoiVienDangKy: false,
    hoiVienId: "",
    hoiVienGioiThieuId: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [visible1, setVisible1] = useState(true);
  const [visible3, setVisible3] = useState(false);
  const [visible4, setVisible4] = useState(false);
  const [btn1Visible, setBtn1Visible] = useState(false);
  const [visible1_1, setVisible1_1] = useState(false);
  const [visible2_1, setVisible2_1] = useState(false);
  const [totalPrice, setPrice] = useState("");
  const [qrCode, setQRCode] = useState("");
  const [bank_url, setBankURL] = useState("");
  const [NoOfTicket, setNoOfTicket] = useState(1);
  const [TicketType, setTicketType] = useState("");
  const [dataEnd, setdataEnd] = useState(false);
  const [enabled, setEnabled] = useState(false);
  const [enabled_column1, setEnabled_column1] = useState(true);
  const [visibleOption1, setvisibleOption1] = useState(false);
  const [visibleOption2, setvisibleOption2] = useState(false);
  const [Referer, setReferer] = useState("");
  const [txt_form_thongbao_0, setthongbao_0] = useState("Đăng ký thành công");
  const [txt_form_thongbao_1, setthongbao_1] = useState("");
  const [txt_form_thongbao_2, setthongbao_2] = useState("Email xác nhận & Tin nhắn ZNS sẽ được gửi trong vòng 5 phút");
  const [btn1disable, setbtn1disable] = useState(false);
  const [isHoiVienLocked, setIsHoiVienLocked] = useState(false);

  // Dynamic API and Event State (Fully Scoped)
  const [eventId, setEventId] = useState(null);
  const [vouchers, setVouchers] = useState([]);
  const [voucher, setVoucher] = useState(undefined);
  const [currentEvent, setCurrentEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [eventOwner, setEventOwner] = useState(null);
  const [ticketTypes, setTicketTypes] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const [refererOptions, setRefererOptions] = useState([]);
  const [isEnglish, setIsEnglish] = useState(false);
  const [khoaHoc, setKhoaHoc] = useState("");

  useEffect(() => {
    setBankURL("https://www.ledr.com/colours/white.jpg");

    const search = new URL(window.location).searchParams;
    const fetchedEventId = search.get("eventId");
    const isEng = search.get("English") === "true";

    setEventId(fetchedEventId);
    setIsEnglish(isEng);

    if (fetchedEventId) {
      Initialize(fetchedEventId);
    }

    // // 1. Define your 3 unique PageSense tracking URLs
    // const pageSenseUrls = ["https://cdn.pagesense.io/js/zoho6828/b5fea5f2a89d4cf58dbcd06edcddff10.js"];

    // // 2. Loop and append each script element once
    // const scriptElements = pageSenseUrls.map((url) => {
    //   const script = document.createElement("script");
    //   script.src = url;
    //   script.async = true;
    //   script.type = "text/javascript";
    //   document.head.appendChild(script);
    //   return script;
    // });

    // // 3. Cleanup: Remove scripts cleanly if the component unmounts
    // return () => {
    //   scriptElements.forEach((script) => {
    //     if (document.head.contains(script)) {
    //       document.head.removeChild(script);
    //     }
    //   });
    // };
  }, []);

  //
  // Pure Initialization Engine (No Global Mutators)
  //
  async function Initialize(currentEventId) {
    try {
      const voucherResponse = await GetVouchers(currentEventId);
      const creatorEventData = await GetCurrentEvent(currentEventId);
      const eventData = creatorEventData?.["data"] || null;

      setVouchers(voucherResponse?.["data"] || []);
      setCurrentEvent(eventData);
      setEventOwner(eventData?.["Payon"]?.["display_value"] || null);

      let initialTicketType = "";
      let initialTicketPrice = 0;
      let parsedTicketTypes = [];

      if (eventData && eventData["Ticket_type"]) {
        const array_loai_ve = eventData["Ticket_type"].split("\n");

        for (let i = 0; i < array_loai_ve.length; i++) {
          const array_loai_ve_i = array_loai_ve[i].split(",");
          const this_loai_ve = {
            option_id: "loai_ve" + i,
            loai_ve: array_loai_ve_i[0] || "",
            gia: Number(array_loai_ve_i[1]) || 0,
            eng_loai_ve: array_loai_ve_i[2] || "",
            so_luong: array_loai_ve_i[3] || "0",
            disable: "false",
          };
          parsedTicketTypes.push(this_loai_ve);
        }

        setTicketTypes(parsedTicketTypes);

        if (parsedTicketTypes.length > 0) {
          initialTicketType = parsedTicketTypes[0].loai_ve;
          initialTicketPrice = parsedTicketTypes[0].gia;
          setTicketType(initialTicketType);
        }

        if (currentEventId === "4246561000005522003") {
          setvisibleOption1(true);
          setvisibleOption2(true);
        }
      }

      const basePrice = eventData ? Number(eventData["Ticket_Price"]) || initialTicketPrice : 0;
      let initialTotal = basePrice * 1; // Default tickets count is 1

      if (eventData && eventData["Early_bird"] === "true") {
        const discountVal = Number(eventData["Discount_Value"]) || 0;
        initialTotal = (initialTotal * (100 - discountVal)) / 100;
      }
      setPrice(initialTotal);

      setFormData({
        type: "UPDATE_FIELDS",
        values: {
          Ticket_type: initialTicketType,
          Price: initialTotal,
          Number_of_Tickets: 1,
          Merchant_Request_Id: Math.floor(Date.now() / 1000),
          Event_name: eventData?.["Event_name"] || "",
          Ticket_price: basePrice,
          Event_code: currentEventId,
          Company: "",
          Address: "",
          Tax_code: "",
          Position: "",
          ZNS_ID: eventData?.["ZNS_ID"] || "",
          Zeptomail_ID: eventData?.["Zeptomail_ID"] || "",
          LayHoaDon: false,
        },
      });

      setTimeout(() => {
        setEnabled(true);
      }, 3000);

      // Fetch member lists safely without storing on window/global variables
      const hoivienData = await GetHoiVienCSMO();
      setMemberList(hoivienData || []);

      const parsedOptions = (hoivienData || []).map((e) => ({
        value: e.Hoi_vien_CSMO.Ten_va_cong_ty,
        label: e.Hoi_vien_CSMO.Ten_va_cong_ty,
      }));
      setRefererOptions(parsedOptions);
    } catch (error) {
      console.error("Lỗi khi khởi tạo:", error);
    } finally {
      setLoading(false);
    }
  }

  //
  // Field Handlers
  //
  const handleChange = async (event) => {
    const { name, value, type, checked } = event.target;
    const isCheckBox = type === "checkbox";

    if (name === "Mobile") {
      let hoivienFormData = {};
      let reset = true;

      if (memberList && memberList.length > 0) {
        if (value) {
          const find_phone = memberList.find((e) => e.Hoi_vien_CSMO.Sdt === value);

          if (find_phone != null) {
            reset = false;

            if (debugging) console.log(find_phone);

            const Hoivien_Ten_va_cong_ty = find_phone.Hoi_vien_CSMO.Ten_va_cong_ty.replace(" - ", ";").split(";");
            const Hoivien_HoTen = Hoivien_Ten_va_cong_ty[0].split(" ");
            const Hoivien_Ten = Hoivien_HoTen[Hoivien_HoTen.length - 1];
            const Hoivien_Email = find_phone.Hoi_vien_CSMO.Email;
            const Hoivien_Company = Hoivien_Ten_va_cong_ty[1] || "";
            const Hoivien_Gender = find_phone.Hoi_vien_CSMO.Male ? "Nam" : "Nữ";

            setNoOfTicket(1);
            setIsHoiVienLocked(true);

            hoivienFormData = {
              First_name: Hoivien_Ten_va_cong_ty[0].replace(" " + Hoivien_Ten, ""),
              Last_name: Hoivien_Ten,
              Email: Hoivien_Email,
              Company: Hoivien_Company,
              Position: "Lãnh đạo (C-level)",
              Gender: Hoivien_Gender,
              Number_of_Tickets: 1,
              isHoiVienDangKy: false,
              isHoiVienChinhThuc: true,
              hoiVienId: find_phone.Hoi_vien_CSMO.Creator_ID,
            };

            if (eventOwner === "CSMO") {
              hoivienFormData.Voucher = "CSMOVIP";
              const foundVoucher = vouchers.find((x) => x.Voucher === "CSMOVIP");
              setVoucher(foundVoucher);

              const currentBasePrice = formData.Ticket_price || 0;
              CalculateDiscount(foundVoucher, 1, currentBasePrice);
            } else {
              const currentBasePrice = formData.Ticket_price || 0;
              CalculateDiscount(undefined, 1, currentBasePrice);
            }
          }
        }
      }

      if (reset && isHoiVienLocked) {
        setNoOfTicket(1);
        setVoucher(undefined);
        const currentBasePrice = formData.Ticket_price || 0;
        CalculateDiscount(undefined, 1, currentBasePrice);

        hoivienFormData = {
          First_name: "",
          Last_name: "",
          Email: "",
          Company: "",
          Position: "",
          Gender: "",
          Voucher: "",
          Number_of_Tickets: 1,
          isHoiVienDangKy: false,
          isHoiVienChinhThuc: false,
          hoiVienId: "",
        };

        setIsHoiVienLocked(false);
      }

      setFormData({
        type: "UPDATE_FIELDS",
        values: {
          Mobile: value,
          ...hoivienFormData,
        },
      });
      return;
    }

    if (name === "LayHoaDon") {
      setVisible1_1(checked);
      setdataEnd(!dataEnd);
    }

    if (name === "bank") {
      if (value === "") {
        setBankURL("https://www.ledr.com/colours/white.jpg");
      } else {
        setBankURL("https://payment.vimo.vn/images/bank/favicon/" + value + ".png");
        if (!visible2_1) {
          setVisible2_1(true);
        }
      }
    }

    setFormData({
      name: name,
      value: isCheckBox ? checked : value,
    });
  };

  const voucherChange = async (event) => {
    const { name, value } = event.target;

    if (name === "Voucher") {
      const foundVoucher = vouchers.find((x) => x.Voucher === value.toUpperCase());
      let updateFields = { Voucher: value };

      let targetedTicketType = TicketType;
      let targetedTicketPrice = formData.Ticket_price || 0;
      let targetedTicketCount = NoOfTicket;

      if (foundVoucher !== undefined) {
        if (debugging) console.log(foundVoucher);

        setVoucher(foundVoucher);

        if (foundVoucher["Applied_for_specific_ticket"] === "true") {
          setEnabled_column1(false);
          targetedTicketType = foundVoucher["Applied_ticket"];
          setTicketType(targetedTicketType);

          targetedTicketPrice = ticketTypes.find((e) => e.loai_ve === targetedTicketType)?.gia || 0;

          updateFields.Ticket_type = targetedTicketType;
          updateFields.Ticket_price = targetedTicketPrice;
        }

        if (foundVoucher["one_ticket_per_use"] === "true") {
          setEnabled(false);
          targetedTicketCount = 1;
          setNoOfTicket(1);
          updateFields.Number_of_Tickets = 1;
        }

        CalculateDiscount(foundVoucher, targetedTicketCount, targetedTicketPrice);
      } else {
        setEnabled(true);
        setVoucher(undefined);
        CalculateDiscount(undefined, targetedTicketCount, targetedTicketPrice);
      }

      setFormData({
        type: "UPDATE_FIELDS",
        values: updateFields,
      });
    }

    if (name === "Number_of_Tickets") {
      const parsedCount = Number(value) || 1;
      setNoOfTicket(parsedCount);
      CalculateDiscount(voucher, parsedCount, formData.Ticket_price);
      setFormData({
        name: name,
        value: value,
      });
    }
  };

  //
  // Dynamic Discount Calculation Engine
  //
  function CalculateDiscount(_voucher, explicitCount, explicitPrice) {
    const activePrice = explicitPrice !== undefined ? explicitPrice : formData.Ticket_price || 0;
    const activeCount = explicitCount !== undefined ? explicitCount : NoOfTicket;

    let normal_price = activePrice * activeCount;
    let Final_price = normal_price;
    let hoi_vien_csmo = false;
    let Discount_by_ticket = 0;

    if (_voucher !== undefined && _voucher !== null) {
      if (_voucher["Ma_hoi_vien"] === "true") {
        hoi_vien_csmo = true;
      }

      if (_voucher["Status"] === "Active" && Number(_voucher["Use_time"] || 0) > 0) {
        let effectVal = Number(_voucher["Effect_Value"] || 0);
        let Discount_by_voucher = 0;

        if (_voucher["Value_Type"] === "Percent") {
          Discount_by_voucher = (normal_price * effectVal) / 100;
        } else if (_voucher["Value_Type"] === "Minus") {
          Discount_by_voucher = effectVal;
        } else if (_voucher["Value_Type"] === "Fixed") {
          Discount_by_voucher = activeCount * effectVal;
        } else if (_voucher["Value_Type"] === "Fixed Percent") {
          Discount_by_voucher = (activeCount * normal_price * effectVal) / 100;
        }

        Final_price = normal_price - Discount_by_voucher;
      }
    } else if (currentEvent && currentEvent["Early_bird"] === "true") {
      let discount_value = Number(currentEvent["Discount_Value"] || 0);
      Final_price = Final_price - normal_price * (discount_value / 100);
    }

    if (activeCount >= 5 && !hoi_vien_csmo) {
      if (eventOwner === "CSMO" || (eventOwner === "Le Bros" && currentEvent?.["txt_Price"] !== "Blind sale")) {
        Discount_by_ticket = (Final_price * 10) / 100;
      }
    }

    Final_price = Final_price - Discount_by_ticket;
    if (Final_price < 0) Final_price = 0;

    setPrice(Final_price);
    setFormData({
      name: "Price",
      value: Final_price,
    });
  }

  //
  // Ticket Count Controls
  //
  const incrementCount = () => {
    if (NoOfTicket < 10) {
      const nextCount = NoOfTicket + 1;
      setNoOfTicket(nextCount);
      CalculateDiscount(voucher, nextCount, formData.Ticket_price);

      setFormData({
        name: "Number_of_Tickets",
        value: nextCount,
      });
    }
  };

  const decrementCount = () => {
    const minLimit = TicketType?.includes("ECO") ? 2 : 1;

    if (NoOfTicket > minLimit) {
      const nextCount = NoOfTicket - 1;
      setNoOfTicket(nextCount);
      CalculateDiscount(voucher, nextCount, formData.Ticket_price);

      setFormData({
        name: "Number_of_Tickets",
        value: nextCount,
      });
    }
  };

  const onChangeRadio = (event) => {
    const selectedType = event.target.value;
    let currentCount = NoOfTicket;

    if (selectedType.includes("ECO") && NoOfTicket < 2) {
      currentCount = 2;
      setNoOfTicket(2);
    }

    setTicketType(selectedType);
    const selectedPrice = ticketTypes.find((e) => e.loai_ve === selectedType)?.gia || 0;

    setFormData({
      type: "UPDATE_FIELDS",
      values: {
        Ticket_type: selectedType,
        Ticket_price: selectedPrice,
        Number_of_Tickets: currentCount,
      },
    });

    CalculateDiscount(voucher, currentCount, selectedPrice);
  };

  // Handle người giới thiệu
  const handleChangeReferer = (selectedOption) => {
    let updateReferer = { hoiVienGioiThieuId: "" };

    if (selectedOption != null) {
      setReferer(selectedOption);
      const refererRecord = memberList.find((e) => e.Hoi_vien_CSMO.Ten_va_cong_ty === selectedOption.value);
      if (refererRecord) {
        updateReferer.hoiVienGioiThieuId = refererRecord.Hoi_vien_CSMO.Creator_ID;
      }
    } else {
      setReferer("");
    }

    if (debugging) console.log(updateReferer.hoiVienGioiThieuId);

    setFormData({
      type: "UPDATE_FIELDS",
      values: updateReferer,
    });
  };

  //
  // Form Submission Block
  //
  const handleClick1 = async (e) => {
    e.preventDefault();
    let Validate = 0;
    let alert_msg = "Vui lòng nhập ";

    if (debugging) console.log("Form Data:", formData);

    // 1. Validate Invoice info if the user requested a tax invoice
    if (formData["LayHoaDon"] === true) {
      if (!formData["Company"]) {
        Validate = 1;
        alert_msg += "Tên công ty";
      }
      if (!formData["Address"]) {
        if (Validate > 0) alert_msg += ", ";
        Validate = 1;
        alert_msg += "Địa chỉ";
      }
      if (!formData["Tax_code"]) {
        if (Validate > 0) alert_msg += ", ";
        Validate = 1;
        alert_msg += "Mã số thuế";
      }
    }

    if (Validate === 1) {
      alert(alert_msg);
    } else {
      // Pack the current React states for Zoho Creator
      const currentBookingState = { formData, TicketType, NoOfTicket, khoaHoc };

      // Transition away from Form 1
      setVisible1(false);
      if (typeof setVisible3 === "function") setVisible3(false); // Just in case Form 3 was somehow referenced

      // 2. Set dynamic greeting/success texts based on selected language and gender
      const computedXungHo = formData["Gender"] === "Nam" ? (isEnglish ? "Mr." : "anh") : isEnglish ? "Ms." : "chị";

      // Note: Update these setter names if they are named slightly differently in your state hook declarations
      if (isEnglish) {
        setthongbao_0("Registration completed successfully!");
        setthongbao_1("The confirmation Email & ZNS message will be sent within 5 minutes.");
        setthongbao_2("Thank you!");
      } else {
        setthongbao_0("Đăng ký thành công!");
        setthongbao_1(
          `Cảm ơn ${computedXungHo} ${formData["Last_name"]} đã đăng ký sự kiện ${formData["Event_name"] || ""}.`,
        );
        setthongbao_2("Thông tin vé cùng các hướng dẫn tiếp theo sẽ được gửi qua Email & ZNS của bạn.");
      }

      // 3. Immediately display the Success Notification Form (visible4)
      setVisible4(true);

      // 4. Silently post the data to Zoho Creator in the background with a blank QR code
      try {
        const data = await InsertNewTicketBooking("", currentBookingState);
        if (debugging) console.log("Direct Insert Success (PayOS Bypassed):", data);
      } catch (error) {
        console.error("Failed to insert booking data:", error);
        if (typeof InsertErrorLog === "function") {
          InsertErrorLog(error.message, formData);
        }
      }
    }
  };

  // --- Dynamic UI Lock Styling Computed right before rendering ---
  const inputLockStyle = isHoiVienLocked ? { color: "#666666", backgroundColor: "#E8ECEF" } : {};

  const spanTransformStyle = isHoiVienLocked ? { transform: "translateX(-5px) translateY(-26px)" } : {};

  // --- Reactive Translation Object Definition ---
  const langText = {
    First_name: isEnglish ? "First name" : "Họ & đệm",
    Last_name: isEnglish ? "Last name" : "Tên",
    Gender: isEnglish ? "Gender" : "Giới tính",
    Male: isEnglish ? "Male" : "Nam",
    Female: isEnglish ? "Female" : "Nữ",
    txt_Ve: isEnglish ? (NoOfTicket === 1 ? "Ticket" : "Tickets") : "Vé",
    txt_thanh_tien: currentEvent?.["txt_Price"] || "Thành tiền",
    txt_Company: isEnglish ? "Company" : "Tên công ty",
    txt_Position: isEnglish ? "Position" : "Vị trí",
    txt_Dang_ky: isEnglish ? "Register" : "Đăng ký",
    txt_guide_het_ve: isEnglish ? "SOLD OUT" : "ĐÃ HẾT VÉ",
    txt_guide_0: isEnglish ? "REGISTRATION GUIDES" : "HƯỚNG DẪN ĐĂNG KÝ VÉ",
    txt_guide_1: isEnglish ? "Step 1: Fill in the box your information" : "Bước 1: Điền thông tin cá nhân",
    txt_guide_2: isEnglish
      ? "Step 2: Select your desired date and the number of ticket(s). Please note that quantities are limited. Maximum 2 tickets per turn"
      : "Bước 2: Chọn ngày và số lượng vé mong muốn. Lưu ý số lượng có hạn. Mỗi lượt tối đa 2 vé",
    txt_guide_3: isEnglish
      ? "Step 3: Receive your ticket via email and Zalo. Please check in at the door using the QR code received."
      : "Bước 3: Nhận thông tin vé QR code qua email và Zalo (mã đăng ký). Vui lòng checkin tại cửa bằng mã QR đã được nhận.",
  };

  return (
    <div className="wrapper">
      {submitting && (
        <div>
          You are submitting the following:
          <ul>
            {Object.entries(formData).map(([name, value]) => (
              <li key={name}>
                <strong>{name}</strong>:{value?.toString()}
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className="img_div"></div>

      {/* Form đăng ký */}
      <div id="form-1" className={visible1 ? "element-visible" : "element-hidden"}>
        <form onSubmit={handleClick1}>
          {eventId === "4246561000014272015" && (
            <div className="Guide">
              <h1 style={{ textAlign: "center" }}>{langText.txt_guide_het_ve}</h1>
              <h5>{langText.txt_guide_0}</h5>
              <p>{langText.txt_guide_1}</p>
              <p>{langText.txt_guide_2}</p>
              <p>{langText.txt_guide_3}</p>
            </div>
          )}

          <div className="inputBox">
            <input
              type="text"
              name="Mobile"
              id="Mobile"
              value={formData.Mobile || ""}
              required
              onChange={handleChange}
            />
            <span data-end="*">Mobile</span>
          </div>

          <div className="NameDiv">
            <div className="Firstname_div">
              <input
                className="left"
                type="text"
                name="First_name"
                id="First_name"
                value={formData.First_name || ""}
                disabled={isHoiVienLocked}
                style={inputLockStyle}
                required
                onChange={handleChange}
              />
              <span id="spanFirstName" data-end="*" style={spanTransformStyle}>
                {langText.First_name}
              </span>
            </div>
            <div className="Lastname_div">
              <input
                className="right"
                type="text"
                name="Last_name"
                id="Last_name"
                value={formData.Last_name || ""}
                disabled={isHoiVienLocked}
                style={inputLockStyle}
                required
                onChange={handleChange}
              />
              <span id="spanLastName" data-end="*" style={spanTransformStyle}>
                {langText.Last_name}
              </span>
            </div>
          </div>

          <div className="inputBox" style={{ marginBottom: "22px" }}>
            <input
              type="text"
              name="Email"
              id="Email"
              value={formData.Email || ""}
              disabled={isHoiVienLocked}
              style={inputLockStyle}
              required
              onChange={handleChange}
            />
            <span id="spanEmail" data-end="*" style={spanTransformStyle}>
              Email
            </span>
          </div>

          {eventId !== "4246561000014272015" && (
            <div className="inputBox3" style={{ marginBottom: "45px" }}>
              <label htmlFor="Company" className="label1">
                <span className={dataEnd ? "span1" : "span2"} data-end="*">
                  {langText.txt_Company}
                </span>
                <span style={{ marginLeft: "120px" }}>{langText.txt_Position}</span>
              </label>
              <input
                id="Company"
                className="input1"
                type="text"
                name="Company"
                value={formData.Company || ""}
                disabled={isHoiVienLocked}
                style={inputLockStyle}
                onChange={handleChange}
              />
              <select
                id="Position"
                className="input2 padding7"
                name="Position"
                value={formData.Position || ""}
                disabled={isHoiVienLocked}
                style={inputLockStyle}
                onChange={handleChange}
              >
                <option value=""></option>
                <option value="Lãnh đạo (C-level)">Lãnh đạo (C-level)</option>
                <option value="Quản lý (Manager)">Quản lý (Manager)</option>
                <option value="Nhân viên (Staff)">Nhân viên (Staff)</option>
                <option value="Khác (Other)">Khác (Other)</option>
              </select>
            </div>
          )}

          <div className="gender">
            <label className="label_gender" data-end="*">
              {langText.Gender}
            </label>
            <input
              className="radio_gender"
              type="radio"
              id="nam"
              name="Gender"
              value="Nam"
              checked={formData.Gender === "Nam"}
              disabled={isHoiVienLocked}
              onChange={handleChange}
              required
            />
            <label htmlFor="nam">{langText.Male}</label>
            <input
              className="radio_gender"
              type="radio"
              id="nu"
              name="Gender"
              value="Nữ"
              checked={formData.Gender === "Nữ"}
              disabled={isHoiVienLocked}
              onChange={handleChange}
            />
            <label htmlFor="nu">{langText.Female}</label>
          </div>

          {eventOwner === "Le Bros" && (
            <span className="txt_span">
              <input
                style={{ marginBottom: "5px" }}
                type="checkbox"
                id="LayHoaDon"
                name="LayHoaDon"
                checked={!!formData.LayHoaDon}
                onChange={handleChange}
              />
              <label htmlFor="LayHoaDon">Anh/Chị có muốn xuất hóa đơn?</label>
            </span>
          )}

          <div className={visible1_1 ? "element-visible" : "element-hidden"}>
            <div className="inputBox2" style={{ marginBottom: "40px" }}>
              <span data-end="*">Địa chỉ</span>
              <input type="text" name="Address" value={formData.Address || ""} onChange={handleChange} />
            </div>
            <div className="inputBox2" style={{ marginBottom: "45px" }}>
              <span data-end="*">Mã số thuế</span>
              <input type="text" name="Tax_code" value={formData.Tax_code || ""} onChange={handleChange} />
            </div>
          </div>

          {eventId !== "4246561000016711003" && (
            <div className={`row ${enabled ? "enabled" : "disabled"}`}>
              <div className={`column1 ${enabled_column1 ? "enabled" : "disabled"}`}>
                {!isEnglish && (
                  <div className="radio_loaive">
                    {ticketTypes.map((option) => (
                      <span key={option.option_id}>
                        <input
                          type="radio"
                          name="Ticket_type"
                          checked={TicketType === option.loai_ve}
                          value={option.loai_ve}
                          id={option.option_id}
                          onChange={onChangeRadio}
                        />{" "}
                        {option.loai_ve}
                        <br />
                      </span>
                    ))}
                  </div>
                )}

                {eventId === "4246561000014272015" && isEnglish && (
                  <div className="radio_loaive" style={{ marginTop: "10px" }}>
                    {ticketTypes.map((option) => (
                      <span key={option.option_id}>
                        <input
                          type="radio"
                          name="Ticket_type"
                          checked={TicketType === option.loai_ve}
                          value={option.loai_ve}
                          id={option.option_id}
                          onChange={onChangeRadio}
                        />{" "}
                        {option.eng_loai_ve}
                        <br />
                      </span>
                    ))}
                  </div>
                )}

                {eventOwner === "CSMO" && (
                  <div className="Voucher-mini">
                    <span>Voucher</span>
                    <input
                      id="Voucher"
                      type="text"
                      name="Voucher"
                      value={formData.Voucher || ""}
                      disabled={isHoiVienLocked}
                      style={inputLockStyle}
                      onChange={voucherChange}
                    />
                  </div>
                )}
              </div>

              <div className="column2">
                <div className="ticket-group">
                  <input
                    className="element-hidden"
                    type="number"
                    name="Number_of_Tickets"
                    value={NoOfTicket}
                    readOnly
                    required
                    min="1"
                  />
                  <button id="increBtn" type="button" className="vertical-btn" onClick={incrementCount}>
                    ˄
                  </button>
                  <div>
                    <span className="ticket">{NoOfTicket}</span>
                    <span className="Ve">{langText.txt_Ve}</span>
                  </div>
                  <button id="decreBtn" type="button" className="vertical-btn" onClick={decrementCount}>
                    ˅
                  </button>
                </div>
              </div>
            </div>
          )}

          {eventOwner === "Le Bros" && (
            <div className="Voucher">
              <span>Voucher</span>
              <input
                id="Voucher"
                type="text"
                name="Voucher"
                value={formData.Voucher || ""}
                disabled={isHoiVienLocked}
                style={inputLockStyle}
                onChange={voucherChange}
              />
            </div>
          )}

          {currentEvent?.["Event_CSMO"] === "true" && (
            <div className="Referer">
              <label htmlFor="Referer">
                <span className="label1">Người giới thiệu (không bắt buộc)</span>
              </label>
              <Select
                id="Referer"
                value={Referer}
                onChange={handleChangeReferer}
                options={refererOptions}
                isClearable
              />
            </div>
          )}

          {eventId !== "4246561000016711003" && (
            <div className="inputBox2">
              <span>
                {langText.txt_thanh_tien} {eventOwner === "Le Bros" ? "cho tới ngày 01/09/2025" : ""}
              </span>
              <CurrencyInput
                suffix=" đ"
                disabled
                className="Currency"
                name="Price"
                value={totalPrice}
                onChange={handleChange}
              />
            </div>
          )}

          <div className="btn_group">
            <input
              hidden={btn1Visible}
              disabled={btn1disable}
              className="btn-grad"
              type="submit"
              value={langText.txt_Dang_ky}
            />
          </div>
        </form>
      </div>

      {/* Form QR code */}
      <div className={`formQR ${visible3 ? "element-visible" : "element-hidden"}`}>
        <p>{underQRText}</p>
        <img alt="qr" width="300" height="300" src={qrCode || ""} />
        <div className="txt_group">
          <img src={img_quet_qr} alt="huong_dan_quet_qr" />
          <h5>{txt_form_QR4}</h5>
          <h5>{txt_form_QR5}</h5>
        </div>
      </div>

      {/* Form thông báo thành công */}
      <div className={`formThongBao ${visible4 ? "element-visible" : "element-hidden"}`}>
        <img
          alt="ok_icon"
          src="https://upload.wikimedia.org/wikipedia/commons/3/3b/Eo_circle_green_checkmark.svg"
          width="80px"
          height="80px"
        />
        <h2 className="green">{txt_form_thongbao_0}</h2>
        <h3>{txt_form_thongbao_1}</h3>
        <h4>{txt_form_thongbao_2}</h4>
      </div>
    </div>
  );
}

export default App;
